import React, { useState, useEffect } from 'react';
import { historyPropType } from '~/config/routerPropTypes';
import { showProduct } from '~/config/routes';
import Request from '~/providers/Request';
import ProductRecord from '~/records/ProductRecord';

import Form from './Form';
import { toast } from 'react-toastify';

function EditRecord({ history }) {
  const [record, setRecord] = useState(new ProductRecord());
  const [loading, setLoading] = useState(false);
  const { id } = history.location.route.getParams();

  useEffect(() => {
    async function fetchData(id) {
      setLoading(true);
      Request.get(`/admin/products/${id}`, {})
        .then((response) => {
          setLoading(false);

          setRecord(record.updateAttributes(response.data));
        })
        .catch((e) => {
          console.error(e);
          setLoading(false);
        });
    }
    fetchData(id);
  }, []);

  const handleChange = (attrs) => {
    setRecord(record.updateAttributes(attrs));
  };

  async function onSubmit() {
    const data = record.toParams();
    Request.put(`/admin/products/${id}`, data, {}, { controller: 'products' })
      .then((resp) => {
        setLoading(false);
        history.push(showProduct.reverse(resp.data));
        toast.success('Produto atualizado com sucesso!');
      })
      .catch((e) => {
        console.error(e);
        setLoading(false);
      });
  }

  return (
    <Form
      onSubmit={onSubmit}
      record={record}
      handleChange={handleChange}
      loading={loading}
      setRecord={setRecord}
    />
  );
}

EditRecord.propTypes = {
  history: historyPropType,
};

export default EditRecord;
